import LandingPageRoutes from './routes'
import { BrowserRouter } from 'react-router-dom';
import { PageSettingsProvider } from './context/PageContext';

function App() {
  return (
      <BrowserRouter>
        <PageSettingsProvider>
          <LandingPageRoutes />
        </PageSettingsProvider>
      </BrowserRouter>
  );
}

export default App;